<template>
  <div
    class="d-flex flex-column align-end mb-3 mb-md-0 mr-0 mr-md-10 player-details"
  >
    <div v-if="playerRegistration.value" class="player-details-inner">
      <div class="d-flex justify-center align-center player-details__avatar">
        <v-progress-circular
          v-if="playerAvatar.isFileUploading"
          indeterminate
          color="#9e9e9e"
          size="50"
        ></v-progress-circular>

        <v-icon
          v-else-if="!playerAvatar.imageUrl"
          size="50"
          class="mb-2"
          color="#edf0f7"
          >mdi-account-circle</v-icon
        >
        <div
          v-else
          class="player-details__avatar-image-wrapper"
          :style="{
            backgroundImage: `url('${playerAvatar.imageUrl}')`,
            backgroundPosition: 'center',
            backgroundSize: 'cover'
          }"
        ></div>
        <div
          class="player-details__avatar-upload-button d-flex justify-center align-center"
        >
          <v-icon size="15" @click="handlePlayerAvatarCropModal">{{
            playerAvatar.imageUrl ? "mdi-pencil" : "mdi-plus"
          }}</v-icon>
        </div>
      </div>
      <div v-if="playerAvatar.avatarUploadError" class="text-center mt-4">
        <span class="red--text">{{ playerAvatar.avatarUploadError }}</span>
      </div>
      <div class="d-flex flex-column mt-2">
        <span class="player-details__name">{{
          findFormFieldByName("Player First Name")
        }}</span>
        <span class="player-details__name">{{
          findFormFieldByName("Player Last Name")
        }}</span>
        <CommonAnchorLink
          anchor="#profile"
          :text="$t('player_registration.profile')"
        />
        <CommonAnchorLink
          anchor="#fans_and_followers"
          :text="$t('player_registration.fans_and_followers')"
        />
        <CommonAnchorLink
          anchor="#add_ons"
          :text="$t('player_registration.add_ons')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import CommonAnchorLink from "./CommonAnchorLink";
import PlayerRegistrationPlayerDetailsBase from "./PlayerRegistrationPlayerDetailsBase";

export default {
  name: "PlayerRegistrationPlayerDetails",
  components: { CommonAnchorLink },
  mixins: [PlayerRegistrationPlayerDetailsBase],
  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerProfileForm",
      "playerRegistrationDetails",
      "playerRegistration",
      "playerAvatar"
    ])
  },
  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, ["setPlayerAvatar"]),
    findFormFieldByName(name) {
      const foundItem = this.playerProfileForm?.find(
        item => item.name === name
      );

      return foundItem ? foundItem?.value : "";
    },
    handlePlayerAvatarCropModal() {
      this.$emit("showPlayerAvatarCropModal");
    }
  },
  watch: {
    playerRegistrationDetails: function(newValue, oldValue) {
      if (newValue.avatar && newValue.avatar !== oldValue.avatar) {
        this.setPlayerAvatar({
          name: "imageUrl",
          value: `data:image/jpeg;base64,${newValue?.avatar}`
        });
      }
    }
  }
};
</script>

<style scoped>
.player-details {
  flex-basis: 33.3%;
}

.player-details-inner {
  width: 170px;
}

.player-details__avatar {
  position: relative;
  min-width: 170px;
  height: 170px;
  border-radius: 50%;
  background-color: #d3dbe8;
  -webkit-box-shadow: 0px 17px 40px -30px rgba(66, 68, 90, 1);
  -moz-box-shadow: 0px 17px 40px -30px rgba(66, 68, 90, 1);
  box-shadow: 0px 17px 40px -30px rgba(66, 68, 90, 1);
}

.player-details__avatar-upload-button {
  position: absolute;
  bottom: 15px;
  right: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--white-color);
}

.player-details__avatar-image-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.player-details__number {
  font-size: 20px;
  font-weight: var(--font-weight-regular);
  color: var(--dark-color);
}

.player-details__name {
  font-size: 28px;
  font-weight: var(--font-weight-medium);
  color: var(--dark-color);
  word-break: break-word;
}
</style>
